import {
    RaikoBaseCardContainer,
    RaikoTableTitleContainer,
    RaikoGridOneColumn,
    showErrorMessage,
    RaikoCustomTable,
    RaikoDefaultDialogPage,
    DialogSize,
    convertUniversalDateTimeToPersianDateTime, RaikoCustomSimpleActiveDeActiveChip, RaikoCustomTooltip, addNewRowToTable
} from "@moeindal/base-raiko-panel-components";
import {useEffect, useState} from "react";
import {AccountTransactionsService} from "../../../serverService/accountTransactions/AccountTransactionsService";
import {useAuthState} from "../../../context/AuthContext";
import {useParams} from "react-router-dom";
import {detectServerErrorMessage} from "../../../util/detectServerErrorMessage";
import RaikoShowPrice from "../../../raikoComponents/raikoShowPrice/RaikoShowPrice";
import {css} from "@emotion/css";
import AccountMonthlyDepositNewTransaction from "./AccountMonthlyDepositNewTransaction";
import AccountMonthlyDepositReceipt from "./accountMonthlyDepositReceipt/AccountMonthlyDepositReceipt";

export default function AccountMonthlyDeposit() {

    const {fundID} = useAuthState()
    const {id: accountId} = useParams()

    let page = 0
    const size = 25

    const service = new AccountTransactionsService()

    const [totalItems, setTotalItems] = useState(0)
    const [transactions, setTransactions] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [tableLoading, setTableLoading] = useState(false)


    useEffect(() => {
        getDataFromServer()
    }, []);


    function handleRowClicked(id) {
        setTransactionSelectedId(id)
        handleOpenNewTransactionDialog()
    }

    function handleChangePagination(newPage) {
        page = newPage
        getDataFromServer()
    }

    function getDataFromServer() {
        setTableLoading(true)
        service.getAccountTransactionsByAccountId(
            fundID,
            accountId,
            page,
            size
        ).then(response => {
            setPageCount(response.totalPage)
            setTotalItems(response.numberOfItems)

            setTransactions([])
            response.data.map((item, index) => {
                setTransactions(prev => [
                    ...prev,
                    prepareTableRow(
                        item.id,
                        (page * size) + index + 1,
                        item.cleared,
                        item.createdAt,
                        item.amount,
                        item.kind,
                        item.depositedAt,
                        item.depositedByManager,
                        item.depositedByMember,
                        item.currentBalance,
                        item.hasBeenDelayed,
                        item.enabled,
                        item.receiptUrl,
                    )
                ])
            })

        }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setTableLoading(false)
        })
    }


    const [transactionSelectedId, setTransactionSelectedId] = useState(-1);

    const [openAddNewTransactionDialog, setOpenAddNewTransactionDialog] = useState(false);
    const handleOpenNewTransactionDialog = () => setOpenAddNewTransactionDialog(true)
    const handleCloseNewTransactionDialog = () => {
        setTransactionSelectedId(-1)
        setOpenAddNewTransactionDialog(false)
    }


    const [receiptUrl, setReceiptUrl] = useState("");

    const [openReceiptDialog, setOpenReceiptDialog] = useState(false);
    const handleOpenReceiptDialog = () => setOpenReceiptDialog(true)
    const handleCloseReceiptDialog = () => {
        setTransactionSelectedId(-1)
        setOpenReceiptDialog(false)
    }

    function prepareTableRow(
        id,
        number,
        cleared,
        createdAt,
        amount,
        kind,
        depositedAt,
        depositedByManager,
        depositedByMember,
        currentBalance,
        hasBeenDelayed,
        enabled,
        receiptUrl) {

        return {
            id: id,
            number: number,
            depositedAt: depositedAt ? convertUniversalDateTimeToPersianDateTime(depositedAt) : "-",
            hasBeenDelayed: <RaikoCustomSimpleActiveDeActiveChip
                state={!hasBeenDelayed}
                activeStateTitle={"ندارد"}
                deActiveStateTitle={"دارد"}
            />,
            kind: kind === "MANAGER_DEPOSIT" ? "ادمین" : "کاربر",
            depositedBy:
                depositedByManager && depositedByManager !== "" ? depositedByManager :
                    depositedByMember && depositedByMember !== "" ? depositedByMember : "-",
            amount: <RaikoShowPrice amount={amount} centerTextAlign/>,
            status: <RaikoCustomSimpleActiveDeActiveChip
                state={enabled}
                activeStateTitle={"فعال"}
                deActiveStateTitle={"غیرفعال"}
            />,
            access: <RaikoCustomTooltip title={"رسید تراکنش"}>
                <div
                    className={css`
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      cursor: pointer;
                    `}
                    onClick={_ => {
                        setReceiptUrl(receiptUrl)
                        setTransactionSelectedId(id)
                        handleOpenReceiptDialog()
                    }}
                >
                    <div className={"ic-receipt"}/>
                </div>
            </RaikoCustomTooltip>
        }
    }


    function handleAddNewItemToTable(item) {
        const newTransaction = addNewRowToTable(
            prepareTableRow(
                item.id,
                1,
                item.cleared,
                item.createdAt,
                item.amount,
                item.kind,
                item.depositedAt,
                item.depositedByManager,
                item.depositedByMember,
                item.currentBalance,
                item.hasBeenDelayed,
                item.enabled,
                item.receiptUrl,
            ),
            transactions
        )
        setTotalItems(prev => prev + 1)
        setTransactions(newTransaction)
        handleCloseNewTransactionDialog()
    }

    function handleUpdateTable(newItem) {
        getDataFromServer()
        handleCloseNewTransactionDialog()
    }


    return (
        <>
            <RaikoDefaultDialogPage
                onClose={handleCloseNewTransactionDialog}
                open={openAddNewTransactionDialog}
                pageTitle={"تراکنش ماهیانه"}
                dialogSize={DialogSize.SMALL}
            >
                <AccountMonthlyDepositNewTransaction
                    transactionId={transactionSelectedId}
                    handleAddNewTransactionToTable={handleAddNewItemToTable}
                    handleUpdateTransactionInTable={handleUpdateTable}
                />
            </RaikoDefaultDialogPage>

            <RaikoDefaultDialogPage
                onClose={handleCloseReceiptDialog}
                open={openReceiptDialog}
                pageTitle={"رسید تراکنش"}
                dialogSize={DialogSize.WRAP_CONTENT}>

                <AccountMonthlyDepositReceipt
                    receiptUrl={receiptUrl}
                    transactionId={transactionSelectedId}
                />
            </RaikoDefaultDialogPage>

            <RaikoGridOneColumn>
                <RaikoBaseCardContainer>
                    <RaikoGridOneColumn>
                        <RaikoTableTitleContainer
                            title={"واریز ماهانه"}
                            hasAmount
                            amount={totalItems}
                            amountTitle={"تراکنش"}
                            hasCreateNewItem
                            createNewItemTitle={"تراکنش جدید"}
                            handleCreateNewItem={handleOpenNewTransactionDialog}
                        />
                        <RaikoCustomTable
                            header={header}
                            data={transactions}
                            isLoading={tableLoading}
                            pageCount={pageCount}
                            handlePaginationChange={handleChangePagination}
                            rowClicked={handleRowClicked}
                            emptyListTitle={"هیچ تراکنشی برای این حساب یافت نشد."}
                            emptyListSubtitle={"برای ثبت تراکنش جدید بر روی تراکنش جدید کلیک نمایید."}

                        />
                    </RaikoGridOneColumn>
                </RaikoBaseCardContainer>
            </RaikoGridOneColumn>


        </>
    )
}

const header = [
    {
        id: "number",
        label: "#"
    }, {
        id: "amount",
        label: "مبلغ (ریال)"
    }, {
        id: "depositedAt",
        label: "تاریخ پرداخت"
    }, {
        id: "kind",
        label: "نوع واریز"
    }, {
        id: "depositedBy",
        label: "واریز کننده"
    }, {
        id: "hasBeenDelayed",
        label: "تاخیر"
    }, {
        id: "status",
        label: "وضعیت"
    }, {
        id: "access",
        label: "دسترسی"
    },
]
